import PropTypes from 'prop-types';
import { Collapse, Form } from 'react-bootstrap';
import Select from 'react-select';

export const Balcony = ({ handleChangeCaracObj, values, errors, touched }) => {
  const options = [
    { value: '', label: 'Seleccione' },
    { value: 1, label: 'Corrido' },
    { value: 2, label: 'Francés' },
    { value: 3, label: 'Aterrazado' },
    { value: 4, label: 'Simple' }
  ];

  return (
    <div>
      <Form.Group className="d-flex gap-2 align-items-center">
        <Form.Check
          type="checkbox"
          onChange={e => {
            handleChangeCaracObj('balcony.active', e.target.checked);
            if (!e.target.checked) handleChangeCaracObj('balcony.type', '');
          }}
          checked={values?.active || false}
        />

        <Form.Label className="m-0">Balcón</Form.Label>
      </Form.Group>

      <Collapse in={values?.active}>
        <div className="mt-2">
          <Form.Group>
            <Form.Label>Tipo</Form.Label>
            <Select
              value={options.find(option => option.value === values?.type)}
              options={options}
              onChange={option =>
                handleChangeCaracObj(
                  'balcony.type',
                  option?.value && Number(option.value)
                )
              }
              isSearchable={false}
              defaultValue={options[0]}
            />

            {errors?.type && touched?.type && (
              <label className="w-100 text-danger">{errors.type}</label>
            )}
          </Form.Group>
        </div>
      </Collapse>
    </div>
  );
};

Balcony.propTypes = {
  handleChangeCaracObj: PropTypes.func,
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object
};
